// js-cookies
import Cookies from 'js-cookie'; 

// axios
import axios from 'axios';

// Достает accessToken из cookie
export const getAccessToken = () => {
  return Cookies.get("accessToken") || null;
}

// Парсит payload из accessToken в json
export const parseJWTPayload = (token) => {
  try {
    const parts = token.split('.');

    if (parts.length < 2) return null;

    const base64url = parts[1];

    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");

    // добавляем '=' в конце чтобы длина строки была кратна 4, если кратна - не добавляем
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');

    const json = atob(padded);

    return JSON.parse(json);
  } catch {
    return null;
  }
} 

// Проверка на то, авторизован ли пользователь
export const isAuthentificated = () => {
  const token = getAccessToken();

  if (!token) return false;

  const payload = parseJWTPayload(token);

  // exp - время жизни токена в ms 
  const exp = payload?.exp;
  
  if (!exp) return false;
  return Date.now() < exp * 1000;
}

export const clearAccessToken = () => {
  Cookies.remove("accessToken", { path: '/' });
}

// Обновление accessToken в случае, если у него истек срок жизни
export const refreshAccessToken = async () => {
  const prevToken = getAccessToken();

  if (!prevToken) {
    return { success: false, code: 'NO_TOKEN'}
  }

  try {
    const res = await axios.post('/gates/ch/refresh-token', {}, {
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': `Bearer_${prevToken}`
      }
    });

    const data = res.data;

    const messageError = data?.ERROR?.MESSAGE;
    const typeError = data?.ERROR?.CODE;

    if (data?.SUCCESS === false) {
      clearAccessToken();
      return { success: false, code: typeError || 'REFRESH_UNCORRECT', message: messageError}
    }

    const newToken = data?.DATA?.ACCESS_TOKEN;

    if (!newToken) {
      clearAccessToken();
      return { success: false, code: 'NO_NEW_TOKEN' }
    }
    
    Cookies.set('accessToken', newToken, { path: '/' });
    
    return { success: true, token: newToken };

  } catch (error) {
    const statusCode = error?.response?.status;
    console.error(error);

    return { success: false, status: statusCode };
  }
}

export const ensureAuth = async () => {
  const token = Cookies.get("accessToken");

  if (!token) return { success: false, code: 'NO_TOKEN' };

  if (isAuthentificated()) return { success: true };

  const refreshed = await refreshAccessToken();

  if (refreshed.success) return { success: true, token: refreshed.token };
  clearAccessToken(); 

  return {
    success: false,
    code: refreshed.code,
    message: refreshed.message,
    status: refreshed.status
  }
}






